<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/JLyJlU/tc-custom/9780226789408.jpg?1726274071861" alt="This image is the cover for the book Ancient Perspectives"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Ancient Perspectives
      </h1>
      <p class="bookDescription body article font2">
        <p><i>Ancient Perspectives</i> encompasses a vast arc of space and time—Western Asia to North Africa and Europe from the third millennium BCE to the fifth century CE—to explore mapmaking and worldviews in the ancient civilizations of Mesopotamia, Egypt, Greece, and Rome. In each society, maps served as critical economic, political, and personal tools, but there was little consistency in how and why they were made. Much like today, maps in antiquity meant very different things to different people.</p><i>Ancient Perspectives</i> presents an ambitious, fresh overview of cartography and its uses. The seven chapters range from broad-based analyses of mapping in Mesopotamia and Egypt to a close focus on Ptolemy’s ideas for drawing a world map based on the theories of his Greek predecessors at Alexandria. The remarkable accuracy of Mesopotamian city-plans is revealed, as is the creation of maps by Romans to support the proud claim that their emperor’s rule was global in its reach. By probing the instruments and techniques of both Greek and Roman surveyors, one chapter seeks to uncover how their extraordinary planning of roads, aqueducts, and tunnels was achieved. Even though none of these civilizations devised the means to measure time or distance with precision, they still conceptualized their surroundings, natural and man-made, near and far, and felt the urge to record them by inventive means that this absorbing volume reinterprets and compares.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Richard J. A. Talbert
      </h2>
      
      <p class="authorDescription body article"><B>Richard J. A. Talbert</B> is the William Rand Kenan, Jr., Professor of History and Classics and founder of the Ancient World Mapping Center at the University of North Carolina at Chapel Hill. He is the author or editor of numerous books, including the <I>Barrington Atlas of the Greek and Roman World</I> and <I>Rome’s World: The Peutinger Map Reconsidered</I>.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?da9a9b96